"use client";

import { Button, Flex, message } from "antd";
import Link from "next/link";
import { IconTicket } from "@/lib/icons";
import { ENDPOINTS } from "@/constants/endpoint";
import { locationcontext, usercontext } from "@/lib/context";
import { useRouter } from "next/navigation";
import { useContext, useState } from "react";
import { DEV_AUTH_HEADERS } from "@/lib/devHeaders";

export default function RegistrationLimitMessage({ className = "", order_id = null }) {
  const { setUser, user } = useContext(usercontext);
  const { location } = useContext(locationcontext);
  const router = useRouter();
  const [loggingOut, setLoggingOut] = useState(false);

  const currentCity = (location || "ahmedabad").toLowerCase();
  const ticketsUrl = order_id
    ? `/tickets?id=${order_id}`
    : `/tickets`;

  const handleLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/${ENDPOINTS.LOGOUT}`,
        {
          method: "GET",
          credentials: "include",
          headers: { ...DEV_AUTH_HEADERS },
        },
      );
      const response = await res.json();
      if (response?.status) {
        setUser({ is_webview: user?.is_webview });
        router.push("/");
      } else {
        message.error(response?.message || "Could not log out");
      }
    } catch {
      message.error("Could not log out. Please try again.");
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <div
      className={`rounded-xl border border-[#FED7AA] bg-[#FFF7ED] px-4 py-4 text-sm text-[#021526] ${className}`}
    >
      <p className="font-semibold text-base mb-1 m-0">
        You&apos;re already registered for this event
      </p>
      <p className="text-[#57534E] mb-0 leading-relaxed">
        This event allows only one booking per mobile number. Your current
        account has already been used to register. To book again, log out and
        sign in with a different mobile number.
      </p>
      <Flex gap={8} wrap="wrap" className="mt-3">
        <Link href={ticketsUrl}>
          <Button type="default" size="middle" icon={<IconTicket size={16} />}>
            View my ticket
          </Button>
        </Link>
        <Button
          type="primary"
          size="middle"
          loading={loggingOut}
          disabled={loggingOut}
          onClick={handleLogout}
        >
          Use a different number
        </Button>
      </Flex>
    </div>
  );
}
